<template>
  <div>
    <!-- 检品状态详情：  -->
    <el-dialog :title="$t('message.inspectionStatusDetails')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1200px" center>
      <div class="content">
        <!-- {{ tableData }} -->
        <el-table :data="tableData" :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
          <!--  检品单号-->
          <el-table-column align="center" :label="$t('message.inspectionOrderNumber')" prop="inspect_sn" width="150">
          </el-table-column>
          <!--  检品员-->
          <el-table-column align="center" :label="$t('message.inspector')" prop="j_name">
          </el-table-column>
          <!--  番号-->
          <el-table-column align="center" :label="$t('message.mash')" prop="sorting" width="60">
          </el-table-column>
          <!--  图片-->
          <el-table-column align="center" :label="$t('message.picture')">
            <template slot-scope="scope">
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="scope.row.pic" alt="" style="width: 300px; height: 300px" />

                <img :src="scope.row.pic" alt="" slot="reference" style="width: 80px; height: 80px" />

              </el-popover>
            </template>

          </el-table-column>
          <!--  应检数-->
          <el-table-column align="center" :label="$t('message.numberToBeChecked')" prop="num">
          </el-table-column>
          <!--  实检数-->
          <el-table-column align="center" :label="$t('message.checkNumber')" prop="inspect_num">
          </el-table-column>
          <!-- 提交不良数 -->
          <el-table-column align="center" :label="$t('message.submitTheNumberOfBad')" prop="inspect_bad_num">
          </el-table-column>
          <!--  提交检品时间-->
          <el-table-column align="center" :label="$t('message.submitInspectionTime')" prop="submit_at" width="100">
          </el-table-column>
          <!--  检品完成时间-->
          <el-table-column align="center" :label="$t('message.inspectionCompletionTime')" prop="inspect_at" width="100">
          </el-table-column>
          <!--  当前状态-->
          <el-table-column align="center" :label="$t('message.currentState')" prop="status">
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    tableData: { type: Array },
  },
  data() {
    return {
      dialogVisible: false,

    };
  },
  methods: {

  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  display: flex;

  .label {
    flex: 1;
    line-height: 40px;
  }

  .val {
    flex: 3;
  }
}
</style>